import Axios from '@/components/api/axios.js'

export default {
	/**
	 * 查询菜单
	 * menuright	appright	pcmdefault
	 */
	getMenu: (menuType, isFilter, success, failure) => {
		Axios.post('/menu/getMenu.do', {
			menuType,
			isFilter
		}, success, failure);
	},
	/**
	 * 添加或更新菜单
	 * @param {String} rightid
	 * @param {String} rightname 菜单名称
	 * @param {String} righttype 菜单类型：menuright/appright/pcmdefault
	 * @param {Integer} serialno 排序
	 * @param {String} webpage 菜单路径
	 * @param {String} parentid 父级id
	 * @param {String} enable 1启用
	 * @param {String} visible 1启用
	 */
	//顶级
	saveMenuAdd: ( rightname, righttype, serialno, webpage, enable,visible,hasSonMenu,iconFile,memo, success, failure) => {
		Axios.post('/menu/saveMenu.do', {
			rightname,
			righttype,
			serialno,
			webpage,
			enable,
			visible,
			hasSonMenu,
			iconFile,
			memo
		}, success, failure);
	},
	//子级
	saveMenuSon: ( rightname, righttype, serialno, webpage, parentid,enable,visible,hasSonMenu,iconFile,memo, success, failure) => {
		Axios.post('/menu/saveMenu.do', {
			rightname,
			righttype,
			serialno,
			webpage,
			parentid,
			enable,
			visible,
			hasSonMenu,
			iconFile,
			memo
		}, success, failure);
	},
	//修改
	saveMenu: (rightid, rightname, righttype, serialno, webpage, parentid,enable,visible, hasSonMenu,iconFile,memo,success, failure) => {
		Axios.post('/menu/saveMenu.do', {
			rightid,
			rightname,
			righttype,
			serialno,
			webpage,
			parentid,
			enable,
			visible,
			hasSonMenu,
			iconFile,
			memo
		}, success, failure);
	},
	/**
	 * 查询菜单树
	 * @param {String} righttype 菜单类型：menuright/appright/pcmdefault
	 */
	findMenuTreeByType: (type, success, failure) => {
		Axios.post('/menu/findMenuTreeByType.do', {
			type
		}, success, failure);
	},
	/**
	 * 根据id删除菜单
	 * @param {String} id
	 */
	deleteMenuById: (id, success, failure) => {
		Axios.post('/menu/deleteMenuById.do', {
			id
		}, success, failure);
	},
	/**
	 * 获取所有权限
	 */
	// getAllRight: (unitId, success, failure) => {
	// 	Axios.post('/menu/getAllRight.do', {
	// 		unitId
	// 	}, success, failure);
	// },
	/**
	 * 获取所有权限
	 */
	 getAllRight: (unitId, success, failure) => {
		Axios.get('/sysMenu/getAllRight.do', {
			unitId
		}, success, failure);
	},
	/**
	 * 获取角色对应的权限
	 */
	getRightsByRoleIds: (roleIds, success, failure) => {
		Axios.post('/menu/getRightsByRoleIds.do', {
			roleIds
		}, success, failure);
	},
	/**
	 * 获取用户所对应的权限
	 */
	getRightByUserId: (userId, success, failure) => {
		Axios.post('/menu/getRightByUserId.do', {
			userId
		}, success, failure);
	},
}